import { createAction, props } from '@ngrx/store';
import { DocumentTypeSummaryBase } from 'src/app/shared/lib/compliance-shared/models/document-type-summary-base.model';
import { FetchArgs, PagingTokenFixed } from 'src/app/shared/models/core';
import { DocumentType } from 'src/app/compliance/models/document-type';
import { DocAdminRequirementPermissionsDto } from 'src/app/compliance/api/models/doc-admin-requirement-permissions-dto.model';

export const getDocumentTypes = createAction('[Doc Admin Component] Get Document Types');

export const getDocumentTypesSuccess = createAction(
    '[Doc Admin API] Get Document Type Success',
    props<{ documents: PagingTokenFixed<DocumentTypeSummaryBase[]> }>()
);

export const getDocumentTypesFailure = createAction(
    '[Doc Admin API] Get Document Types Failure',
    props<{ error: any }>()
);

export const setDocumentTypesFilter = createAction(
    '[Doc Admin Component] Set Document Types Filter',
    props<{ filter: FetchArgs }>()
);

export const downloadDocumentTypes = createAction(
    '[Doc Admin Component] Download Document Types',
    props<{ documentId: number; fileName: string }>()
);

export const downloadDocumentTypesSuccess = createAction(
    '[Doc Admin API] Download Document Types Success',
    props<{ blob: Blob; fileName: string }>()
);

export const downloadDocumentTypesFailure = createAction(
    '[Doc Admin API] Download Document Types Failure',
    props<{ error: any }>()
);

export const getDocumentTypesList = createAction('[DOCUMENT TYPES COMPONENT] Get Document Types');

export const getDocumentTypesListByName = createAction(
    '[DOCUMENT TYPES COMPONENT] Get Document Types By Name',
    props<{ name: string }>()
);

export const getDocumentTypesListSuccess = createAction(
    '[DOCUMENT TYPES API] Get Document Types Success',
    props<{ documentTypesList: DocumentType[] }>()
);

export const getDocumentTypesListFailure = createAction(
    '[DOCUMENT TYPES API] Get Document Types Failure',
    props<{ error: any }>()
);

export const createDocumentType = createAction(
    '[DOCUMENT TYPES COMPONENT] Create Document Types',
    props<{ documentType: DocumentType }>()
);

export const createDocumentTypeSuccess = createAction(
    '[DOCUMENT TYPES API] Create Document Type Success',
    props<{ id: number }>()
);

export const createDocumentTypeFailure = createAction(
    '[DOCUMENT TYPES API] Create Document Type Failure',
    props<{ error: any }>()
);

export const goToDocumentPage = createAction(
    '[DOCUMENT TYPES COMPONENT] Go To Document Page',
    props<{ documentId: number }>()
);

export const updateDocumentType = createAction(
    '[DOCUMENT TYPES COMPONENT] Update Document Types',
    props<{ documentType: DocumentType; documentId: number }>()
);

export const updateDocumentTypeSuccess = createAction(
    '[DOCUMENT TYPES API] Update Document Types Success',
    props<{ documentType: DocumentType; documentId: number }>()
);

export const updateDocumentTypeFailure = createAction(
    '[DOCUMENT TYPES API] Update Document Failure',
    props<{ documentType: DocumentType; documentId: number }>()
);

export const getDocumentType = createAction(
    '[DOCUMENT TYPES COMPONENT] Get Document Type By Id',
    props<{ id: number }>()
);

export const getDocumentTypeSuccess = createAction(
    '[DOCUMENT TYPES API] Get Document Type By Id Success',
    props<{ documentType: DocumentType }>()
);

export const getDocumentTypeFailure = createAction(
    '[DOCUMENT TYPES API] Get Document Types By Id Failure',
    props<{ error: any }>()
);

export const uploadSupplementalFile = createAction(
    '[DOCUMENT TYPES COMPONENT] Upload Supplemental File',
    props<{ file: any }>()
);

export const uploadSupplementalFileSuccess = createAction(
    '[DOCUMENT TYPES API] Upload Supplemental File Success',
    props<{ file: any }>()
);

export const uploadSupplementalFileFailure = createAction(
    '[DOCUMENT TYPES API] Upload Supplemental File Failure',
    props<{ error: any }>()
);

export const addSubType = createAction(
    '[DOCUMENT TYPES COMPONENT] Add Sub-Type',
    props<{ name: string; id: number }>()
);

export const addSubTypeSuccess = createAction('[DOCUMENT TYPES API] Add Sub-Type Success', props<{ id: number }>());

export const addSubTypeFailure = createAction('[DOCUMENT TYPES API] Add Sub-Type Failure', props<{ error: any }>());

export const addDocCode = createAction(
    '[DOCUMENT TYPES COMPONENT] Add Doc Code',
    props<{ newDocCode: unknown; id: number }>()
);

export const addDocCodeSuccess = createAction('[DOCUMENT TYPES API] Add Doc Code Success', props<{ id: number }>());

export const addDocCodeFailure = createAction('[DOCUMENT TYPES API] Add Doc Code Failure', props<{ error: any }>());

export const editDocCode = createAction(
    '[DOCUMENT TYPES COMPONENT] Edit Doc Code',
    props<{ newDocCode: unknown; id: number; codeId: number }>()
);

export const editDocCodeSuccess = createAction('[DOCUMENT TYPES API] Edit Doc Code Success', props<{ id: number }>());
export const editDocCodeFailure = createAction('[DOCUMENT TYPES API] Edit Doc Code Failure', props<{ error: any }>());

export const deleteDocCode = createAction(
    '[DOCUMENT TYPES COMPONENT] Delete Doc Code',
    props<{ id: number; codeId: number }>()
);

export const deleteDocCodeSuccess = createAction(
    '[DOCUMENT TYPES API] Delete Doc Code Success',
    props<{ id: number }>()
);

export const deleteDocCodeFailure = createAction(
    '[DOCUMENT TYPES API] Delete Doc Code Failure',
    props<{ error: any }>()
);

export const getOcrEnabledStatus = createAction('[DOCUMENT TYPES COMPONENT] Get Ocr Enabled Status');

export const getOcrEnabledStatusSuccess = createAction(
    '[DOCUMENT TYPES COMPONENT] Get Ocr Enabled Status Success',
    props<{ isOcrEnabled: boolean }>()
);

export const getOcrEnabledStatusFailure = createAction(
    '[DOCUMENT TYPES COMPONENT] Get Ocr Enabled Status Failure',
    props<{ error: any }>()
);

export const toggleOcrEnabled = createAction('[DOCUMENT TYPES COMPONENT] Toggle Ocr Enabled Status');

export const toggleOcrEnabledSuccess = createAction(
    '[DOCUMENT TYPES COMPONENT] Toggle Ocr Enabled Status Success',
    props<{ isOcrToggleSuccessful: boolean }>()
);

export const toggleOcrEnabledFailure = createAction(
    '[DOCUMENT TYPES COMPONENT] Toggle Ocr Enabled Status Failure',
    props<{ error: any }>()
);

export const setPreviousNavigationUrl = createAction(
    '[DOCUMENT TYPES COMPONENT] Set Previous Navigation URL',
    props<{ previousNavigationUrl: string }>()
);

// Trigger fetching permissions
export const getRequirementPermissions = createAction('[Document Admin] Get Requirement Permissions');

// On success
export const getRequirementPermissionsSuccess = createAction(
    '[Document Admin] Get Requirement Permissions Success',
    props<{ permissions: DocAdminRequirementPermissionsDto }>()
);

// On failure
export const getRequirementPermissionsFailure = createAction(
    '[Document Admin] Get Requirement Permissions Failure',
    props<{ error: any }>()
);
